import { representativePerks, representativeSteps } from "@/mocks/content";
import { track } from "@/lib/analytics";

export default function Representatives() {
  return (
    <section id="representantes" className="bg-background-50 py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="reveal overflow-hidden rounded-3xl border border-background-200 bg-gradient-to-br from-primary-50 via-background-50 to-background-100 p-8 md:p-14">
          <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="mb-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
                <span className="h-px w-6 bg-current" />
                Programa de representantes
              </span>
              <h2 className="max-w-md font-heading text-3xl font-bold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
                Leve o Play Menu para a sua região.
              </h2>
              <p className="mt-5 max-w-md text-base leading-relaxed text-foreground-600">
                Apresente a experiência aos restaurantes, acompanhe as indicações
                e construa sua carteira de clientes.
              </p>

              <ul className="mt-8 space-y-3">
                {representativePerks.map((perk) => (
                  <li key={perk} className="flex items-start gap-3">
                    <i
                      className="ri-check-line mt-0.5 text-base text-primary-600"
                      aria-hidden="true"
                    />
                    <span className="text-sm leading-relaxed text-foreground-700">
                      {perk}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#contato"
                  onClick={() => track("representative_cta_click")}
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400"
                >
                  Quero ser representante
                </a>
                <a
                  href="#faq"
                  onClick={() => track("faq_click", { location: "representatives" })}
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-full border border-foreground-300 bg-background-50 px-7 py-3.5 text-sm font-semibold text-foreground-900 transition-colors hover:border-foreground-900"
                >
                  Tirar dúvidas
                </a>
              </div>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
              <div className="flex items-center gap-3 border-b border-background-200 pb-5">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
                  <i className="ri-play-fill text-lg" aria-hidden="true" />
                </span>
                <span className="font-heading text-lg font-bold text-foreground-950">
                  Play Menu
                </span>
              </div>

              <h3 className="mt-6 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                Seu próximo cliente pode estar na próxima mesa.
              </h3>

              <div className="mt-6 space-y-3">
                {representativeSteps.map((step) => (
                  <div
                    key={step.n}
                    className="flex items-center gap-4 rounded-xl bg-background-100 px-4 py-4"
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                      {step.n}
                    </span>
                    <div>
                      <p className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {step.title}
                      </p>
                      <p className="text-xs text-foreground-500 md:text-sm">
                        {step.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <p className="mt-6 text-center text-xs text-foreground-400">
                Condições comerciais apresentadas no cadastro.
              </p>
            </div>
          </div>
        </div>

        <p className="reveal mt-6 text-center text-sm text-foreground-500">
          Condições especiais para parceiros — empresas, instituições,
          associações e parceiros comerciais recebem{" "}
          <strong className="font-semibold text-foreground-800">15% de desconto</strong>.
        </p>
      </div>
    </section>
  );
}